import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "../hrmTour.css";

export function startEmployeeListTour() {
  const steps = [{ popover: { title: "Hướng dẫn nhanh", description: "Giới thiệu các vùng chính của trang nhân viên.", side: "over", align: "center" } }];
  const segments = [
    ['[data-tour="hrm-employees-header"]', "Tiêu đề trang", "Hiển thị số nhân viên theo điều kiện đang xem.", "bottom"],
    ['[data-tour="hrm-employees-filter"]', "Bộ lọc nhân viên", "Lọc và thêm mới hồ sơ nhân sự.", "bottom"],
    ['[data-tour="hrm-employees-grid"]', "Danh sách dạng card", "Nhân viên được nhóm theo chi nhánh để tra cứu nhanh.", "top"],
  ];
  for (const [selector, title, description, side] of segments) {
    const el = document.querySelector(selector);
    if (!el) continue;
    steps.push({ element: el, popover: { title, description, side } });
  }
  if (steps.length <= 1) return window.alert("Không tìm thấy vùng để chạy hướng dẫn.");
  driver({ showProgress: true, smoothScroll: true, popoverClass: "hrm-tour-popover", nextBtnText: "Tiếp", prevBtnText: "Trước", doneBtnText: "Xong", progressText: "Bước {{current}} / {{total}}", steps }).drive();
}
